module.exports = __webpack_public_path__ + "img/footer-logo-contour.6b5d95cd.png";